import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import SubmissionsPage from './components/SubmissionsPage';
import AdminOutletDashboard from './components/AdminOutletDashboard';
import { Toaster } from 'sonner';

// Components
import LoadingScreen from './components/LoadingScreen';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import FounderSection from './components/FounderSection';
import GrowthSection from './components/GrowthSection';
import InteractiveMap from './components/InteractiveMap';
import SupplyChainSection from './components/SupplyChainSection';
import TestimonialsSection from './components/TestimonialsSection';
import ComparisonSection from './components/ComparisonSection';
import FranchiseModel from './components/FranchiseModel';
import FAQSection from './components/FAQSection';
import EnquiryForm from './components/EnquiryForm';
import MissionVision from './components/MissionVision';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(() => !sessionStorage.getItem('hasVisitedHome'));

  const handleLoadingComplete = () => {
    sessionStorage.setItem('hasVisitedHome', 'true');
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingScreen onComplete={handleLoadingComplete} />;
  }

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <StorySection />
        <FounderSection />
        <GrowthSection />
        <InteractiveMap />
        <SupplyChainSection />
        <TestimonialsSection />
        <ComparisonSection />
        <FranchiseModel />
        <FAQSection />
        <EnquiryForm />
        <MissionVision />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

import StorePage from './components/StorePage';

function App() {
  // Clean URL if it ends with /index.html before the router initializes
  if (typeof window !== 'undefined' && window.location.pathname.endsWith('/index.html')) {
    const cleanPath = window.location.pathname.replace(/\/index\.html$/, '');
    window.history.replaceState(null, '', cleanPath || '/');
  }

  useEffect(() => {
    // Preload fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App w-full overflow-x-hidden relative bg-background text-foreground transition-colors duration-300">
          <Router>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/submissions" element={<SubmissionsPage />} />
              <Route path="/admin/outlets" element={<AdminOutletDashboard />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/:slug" element={<StorePage />} />
            </Routes>
            <Toaster position="top-center" />
          </Router>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
